export default __webpack_public_path__ + "static/media/3.09509f79.svg";